function o(e, t = "") {
  const r = e === "_all" ? "*" : e;
  return t ? `${t}.${r}` : r;
}
function d(e, t = "") {
  return typeof e == "boolean" || typeof e > "u" ? [] : Object.keys(e).flatMap((r) => {
    const l = e[r];
    return l === !0 ? [o("_all", t)] : r === "_flatten" ? [] : [
      o(r, t),
      ...d(l, o(r, t))
    ];
  });
}
function c(e, t) {
  return typeof t != "object" ? e : Array.isArray(e) ? e.map((r) => c(r, t)) : Object.keys(t).reduce(
    (r, l) => {
      if (l === "_all")
        return r;
      if (l === "_flatten") {
        const s = t, a = t[l], f = r[a];
        return Object.assign(
          r,
          f && a ? c(
            f,
            s[a]
          ) : f
        );
      }
      const n = e;
      if (!e || !(l in e))
        return r;
      const u = n[l];
      return r[l] = typeof u == "object" ? c(u, t[l]) : u, r;
    },
    { ...e }
  );
}
const b = () => (e) => {
  const t = (r, l) => Array.isArray(r) ? r.filter(
    (n) => n != null
  ).map((n) => c(n, l)) : r == null || r === void 0 ? [] : (console.log("Mapping single item", r), [c(r, l)]);
  return {
    map: (r) => t(r, e),
    fields: d(e)
  };
};
export {
  b as createFieldMapper,
  d as getFields
};
